(function ($) {
    init();

    function init() {
        $(document).ready(function () {
            loadAngularApps();
            loadLegacyApps();
        });
    }

    function loadLegacyApps() {
        var $legacyApps = $('[data-wep-app]');
        if (!$legacyApps.length) return false;
        var appScripts = {
            'regionselector': [
                'vendor/d3/d3.min.js',
                'vendor/topojson/topojson.min.js',
                'vendor/angular/angular.min.js',
                'vendor/angular/angular-sanitize.min.js',
                'js/apps/region-selector.min.js'
            ]
        },
            scripts;
        $legacyApps.each(function () {
            scripts = appScripts[sanitizeScriptAttr($(this).data('wep-app'))];
            $.each(scripts, function (i, script) {
                loadAsset(script);
            });
        });
    }

    function sanitizeScriptAttr(attr) {
        return attr ? attr.replace(/\W/g, '') : '';
    }
}(window.jQuery));

function loadAssetsByType(appName) {
    if (appName === 'product-locator' || appName === 'product-locator-ff') {
        isOneTrustLoaded().then(() => {
            const $app = $(`[data-wep2-app="${appName}"]`);
            const mapType = $app.data('map-type');
            if (typeof consentManager !== "undefined" && mapType && !consentManager.isCategoryActive(mapType)) {
                return;
            }
            loadAllAssets(appName);
        });
    } else {
        loadAllAssets(appName);
    }
}

function loadAllAssets(appName) {
    var assets = ['styles.css', 'runtime.js', 'polyfills.js', 'main.js'],
        baseURL = 'js/angular-apps/dist/' + appName + '/';
    $.each(assets, function (index, asset) {
        loadAsset(baseURL + asset);
    });
}

function loadAsset(url) {
    var relURL = '/assets/' + url;

    if (url.indexOf('.js') > -1) {
        $('body').append('<script src="' + relURL + '"/>');
    } else if (url.indexOf('.css') > -1) {
        $('head').append('<link rel="stylesheet" href="' + relURL + '"/>');
    }
}

function appendBaseTag() {
    if (!window.WEP.isPageEditor()) {
        var protocol = window.location.protocol + '//',
            port = window.location.port ? ':' + window.location.port : '',
            baseHref = protocol + window.location.hostname + port + window.location.pathname;
        if (!$('base').length) {
            $('head').append(sanitizeHtmlStrings('<base href="' + baseHref + '">', {
                whiteList: {
                    base: ["href"]
                }
            }));
        }
    }
}

function loadAngularApps() {
    var $apps = $('[data-wep2-app]');
    var showconsent = "";
    
    if (!$apps.length) {
        return false;
    }

    appendBaseTag();
    $apps.each(function () {
        var appName = $(this).data('wep2-app');
        if (appName == 'product-locator') {
            var isPreview = $(this).data('app-config').MAP.isPreview;
            if (!isPreview) {
                showconsent = $(this).data('show-consent');
                if (!showconsent || showconsent === undefined) {
                    loadAssetsByType(appName);
                }
            } else {
                createExperienceEditorPlaceholder($(this));
            }
        } else {
            showconsent = $(this).data('show-consent');
            if (!showconsent || showconsent === undefined) {
                loadAssetsByType(appName);
            }
        }
    });
}

function createExperienceEditorPlaceholder(element) {
    console.log(element);
    var data = element.data('app-config').MAP;
    element.append("<div style='width:100%;height:500px'><h3>MAP COMPONENT PLACEHOLDER</h3><p>Map Provider : " + data.provider + " </p><p>DataSource : " + data.datasource + "</p><div style='background-color:#acc7f2;height:90%;width:100%;'></div></div>");
}

const originalReplaceState = history.replaceState;
history.replaceState = function (...args) {
    var $locatorApp = $('[data-wep2-app]');
    var locAppName = $locatorApp.data('wep2-app');

    if (locAppName === 'product-locator' || locAppName === 'product-locator-ff') {
        if (args[2]) {
            try {
                const url = new URL(args[2], window.location.href);
                if (url.pathname.endsWith("/") && url.pathname.length > 1) {
                    url.pathname = url.pathname.replace(/\/+$/, "");
                    args[2] = url.toString();
                }
            } catch (e) {
                // Invalid URL, do nothing
            }
        }
    }
    return originalReplaceState.apply(this, args);
};